import React, { createElement } from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Set title immediately before React mounts
document.title = 'Megapack Nutrición Resuelta — Consulta Resuelta™';
// Hero image — must match App.tsx (with Cloudinary transforms)
const HERO_BASE = 'https://res.cloudinary.com/dowzlbqlz/image/upload';
const HERO_PATH = '/v1778382523/hf_20260509_035726_3b0b453a-cd00-4b5f-b77d-c15b35a1d726-Photoroom_1_g1m6xf.webp';
// Preconnect to Cloudinary only — the only domain we hit during initial paint
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://res.cloudinary.com';
preconnect.crossOrigin = 'anonymous';
document.head.appendChild(preconnect);
// Preload hero image for fastest LCP. Use modest widths (mobile 320-380px,
// desktop renders at 380px max — 2x retina = 760, so 640w is enough).
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.href = `${HERO_BASE}/f_auto,q_auto,w_640,c_limit${HERO_PATH}`;
(preloadImg as any).fetchPriority = 'high';
preloadImg.imageSrcset = `${HERO_BASE}/f_auto,q_auto,w_400,c_limit${HERO_PATH} 400w, ${HERO_BASE}/f_auto,q_auto,w_640,c_limit${HERO_PATH} 640w`;
preloadImg.imageSizes = '(max-width: 640px) 320px, 380px';
document.head.appendChild(preloadImg);
createRoot(document.getElementById('root')!).render(<App data-id="element-386" />);